import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { GlobalModel } from "../common/utils";

const initialState: GlobalModel = {
  loading: false,
  popUpLoading:false,
  accessToken: "",
};

const globalSlice = createSlice({
  name: "globalSlice",
  initialState,
  reducers: {
    setLoading: (state: GlobalModel, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setPopUpLoading: (state: GlobalModel, action: PayloadAction<boolean>) => {
      state.popUpLoading = action.payload;
    },
    setToken: (state: GlobalModel, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setLoading, setToken, setPopUpLoading } = globalSlice.actions;

export default globalSlice.reducer;
